import http from '../http'

export default {
  getMyAccountInfo(data: object, option: object = {}) {
    return http.get('/profile', data, option);
  },
  getUserLevelInfo() {
    return http.get('/user/level');
  },
  getUserDotMsg() {
    return http.get('/user/dot_msg');
  }
}
